export const COLOR_THEME_LOCAL_STORAGE_KEY = "themePalette";
export const SYNC_THEME_WITH_SYSTEM_LOCAL_STORAGE_KEY = "syncThemeWithSystem";
export const REDUCED_MOTION_LOCAL_STORAGE_KEY = "prefers-reduced-motion";
